import { SprintRef } from '@/tracker/types';

const STATUS_HINTS = { active: ' · идёт', draft: '', closed: ' · закрыт' };

/**
 * Подпись спринта в выборах: доска и статус. Названия повторяются и между досками («Спринт 1»),
 * и внутри одной доски — у закрытого и активного
 */
export const sprintHint = (sprint: Pick<SprintRef, 'board' | 'status'>) =>
  `${sprint.board.name}${STATUS_HINTS[sprint.status]}`;
export { nextSprintDates } from './nextSprintDates';
